import JSShare from 'js-share';

export default class Share{
    constructor(shareBtn, index){
        this.shareBtn = shareBtn
        this.index = index
        
        this.share = this.share.bind(this)

        this.init()
    }

    init(){
        this.addListeners()
    }

    addListeners(){
        this.shareBtn.addEventListener('click', this.share)
    }

    share(){
        // console.log(this.shareBtn)
        return JSShare.go(this.shareBtn);
    }

    static init() {
        Share.items = Array.from(document.querySelectorAll('.social_share'))
                           .map((shareBtn, index) => new Share(shareBtn, index));
    }
}


